import { jsonFetch } from "@/lib/helpers";
import { ServiceContractWithProducts } from "../../../models";
import { getCustomerServiceContractsByUserIdUrl } from "./api-url.constants";
import { CustomerServiceContractsDTO } from "./dtos";
import { mapCustomerServiceContractsDTOtoCustomerServiceContracts } from "./mappers";

export const getCustomerServiceContractsByUserId = async (
  userId?: string
): Promise<ServiceContractWithProducts[]> => {
  const customerServiceContractDTO = await jsonFetch<CustomerServiceContractsDTO>(
    getCustomerServiceContractsByUserIdUrl(userId)
  );
  return mapCustomerServiceContractsDTOtoCustomerServiceContracts(customerServiceContractDTO.data);
};
